import { motion } from "motion/react";
export default function ManifestoSection({ items, biography }) {
  return (
    <section id="manifesto" className="manifesto" aria-labelledby="manifesto-title">
      <div className="section-kicker">
        <span>02 / Manifesto</span>
        <span>Three operating principles</span>
      </div>
      <h2 id="manifesto-title" className="sr-only">
        创作方法论
      </h2>
      <motion.div
        className="manifesto__intro"
        initial={false}
      >
        <p className="manifesto__lead">我不把技术当作答案。</p>
        <p>{biography}</p>
      </motion.div>
      <ol className="manifesto__list">
        {items.map((item) => (
          <motion.li
            key={item.number}
            initial={{ opacity: 0, x: -90 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.72 }}
          >
            <span className="manifesto__number">{item.number}</span>
            <p>{item.text}</p>
            <strong aria-hidden="true">{item.keyword}</strong>
          </motion.li>
        ))}
      </ol>
    </section>
  );
}
